// removed by extract-text-webpack-plugin
module.exports = {"root":"_1bvdL","info":"_3ouDV","details":"vF7CC","figure":"_3UTZX","avatar":"_2y3Za","name":"_1zUkn","description":"_1_bjT"};


//////////////////
// WEBPACK FOOTER
// ../source/components/UserHead/styles.css
// module id = 1296
// module chunks = 6 7 9